<div class="container">
    <div class="close-button" (click)="onClose()">
        <span class="iconify" data-icon="mdi:close" data-inline="false" data-width="24" data-height="24"
            style="color:black"></span>
    </div>
    <div *ngIf="loading" class="loading-div">
        <museum-loader></museum-loader>
    </div>
    <pdf-viewer [src]="url" [original-size]="false" (page-rendered)="pageRendered($event)"></pdf-viewer>
</div>